export { default as HomePage } from "./View";
export { default as Slides } from "./Slides";
